export function assertNotNullish<T>(
  item: T | undefined | null,
  errorMessage: string,
): asserts item is T {
  if (item === undefined || item === null) {
    throw new Error(errorMessage);
  }
}
